import { ACTION_STATUS } from '~/components/Admin/ResourceTable';
import { TOwnInfo } from '~/store/user/user.type';

export const displayName = (ownInfo: TOwnInfo) => {
  const { name, username } = ownInfo;
  if (name) {
    return name;
  } else {
    return username;
  }
};

export const formattedTime = (seconds: number) => {
  const hour = Math.floor(seconds / 60 / 60).toString();
  const minute = Math.floor((seconds - Number(hour) * 60 * 60) / 60).toString();
  const second = (seconds % 60).toString();

  return (
    (hour === '0' ? '' : (hour.length > 1 ? hour : `0${hour}`) + ':') +
    (minute === '0' ? '' : (minute.length > 1 ? minute : `0${minute}`) + ':') +
    (second.length > 1 ? second : `0${second}`)
  );
};

export const getTitleText = (status: ACTION_STATUS, count: number) => {
  switch (status) {
    case ACTION_STATUS.UPLOAD:
      return '表單上傳';
    case ACTION_STATUS.EDIT:
      return '編輯檔案';
    case ACTION_STATUS.BATCH_OFF:
    case ACTION_STATUS.BATCH_ON:
      return `您確定要${status === ACTION_STATUS.BATCH_OFF ? '下' : ''}${
        status === ACTION_STATUS.BATCH_ON ? '上' : ''
      }架這 ${count} 個檔案嗎?`;
    default:
      return '';
  }
};
